import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';

/**
 * Mycotoxin agro-climatic risk. It has no shelf section (not registered in sections.registry) and is
 * driven by the statistics chart through the store's instant-apply `applyValue`. Single string value:
 * a risk index ('0'-'4') or the all sentinel.
 */
export const buildMycotoxinRiskFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.MYCOTOXIN_RISK,
    defaultValue: ALL_FILTER_VALUE,
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const risk = feature.properties?.risk;
      return risk ? [risk] : [];
    },
    matches: (feature, value) => {
      if (value === undefined || value === ALL_FILTER_VALUE) return true;
      return feature.properties?.risk === value;
    }
  });
